import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PromoDistributionPage } from '@/features/promotion/pages/PromoDistributionPage';
import { promoCatalogueSearchSchema } from '@/features/promotion/types/promotion.types';

export const Route = createFileRoute('/_auth/promotion/distribution')({
  validateSearch: promoCatalogueSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Promotional Item Distribution">
      <Suspense fallback={<PageLoader />}>
        <PromoDistributionPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
